import { ClientRegistry } from '../components';
import {
  ClientFilteredComponentSystem,
  FilteredClientComponentSystemUpdateEntityArgs,
} from './ClientBase';

/**
 * Applies horizontal sprite mirroring based on facing direction.
 *
 * For entities with the MirrorX marker, sets Transform.scaleX to:
 * - -1 when facing left (mirror the sprite)
 * - 1 when facing any other direction (no mirror)
 *
 * This allows using right-facing art for both left and right movement.
 *
 * Order: After FacingDirectionSystem, before RenderSystem.
 */
export class FacingScaleSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['Facing', 'MirrorX', 'Transform'];

  updateEntity({ world, entityId }: FilteredClientComponentSystemUpdateEntityArgs): void {
    const facing = world.getComponent(entityId, 'Facing')!;
    const transform = world.getComponent(entityId, 'Transform')!;

    const desiredScaleX = facing.direction === 'left' ? -1 : 1;

    if (transform.scaleX !== desiredScaleX) {
      this.updateComponent(entityId, transform, { scaleX: desiredScaleX });
    }
  }
}
